import { NgModule } from "@angular/core";
import { LockIfSessionIsDeadGuard } from "src/app/guards/lock-if-session-is-dead.guard";
import { AuthGuard } from "./auth.guard";
import { SignoutGuard } from "./signout.guard";
import { ProvideAuthenticatedUserGuard } from "./provide-authenticated-user.guard";
import { ProvideFacilityGuard } from "./provide-facility.guard";
import { ProvideUserGuard } from "./provide-user.guard";
import { ProcessInviteGuard } from "./process-invite.guard";
import { TabCanDeactivateGuard } from "./tab-candeactivate.guard";
import { EnableServerEventsGuard } from "./enable-server-events.guard";
import { ProvideBoxGuard } from "./provide-box.guard";
import { ProvideBreedGuard } from "./provide-breed.guard";
import { CookieAuthStorageGuard } from "./cookie-auth-storage.guard";
import { CommonModule } from "@angular/common";
import { PipesModule } from "../pipes/pipes.module";
import { RoleGuard } from "./role.guard";
import { ProvideMemberGuard } from "./provide-member.guard";
import { ProvideMemberAuthGuard } from "./provide-member-auth/provide-member-auth.guard";
import { DefaultRouteByRoleGuard } from "./default-route-by-role.guard";
import { SessionGuard } from "src/app/guards/session.guard";
import { EnableIdleSessionGuard } from "./enable-idle-session.guard";
import { UpdateGuard } from "src/app/guards/update.guard";
import { ShowUpdateToastGuard } from "src/app/guards/show-update-toast.guard";
import { ProvideColorsGuard } from "src/app/guards/provide-colors.guard";
import { ProvideAvatarGuard } from "src/app/guards/provide-avatar.guard";
import { ProvideFiscalProfilesGuard } from "src/app/guards/provide-fiscal-profiles.guard";
import { EnableThemeGuard } from "src/app/guards/enable-theme.guard";
import { EnableAbac } from "src/app/guards/enable-abac.guard";
import { ProvideMenuGuard } from "src/app/guards/provide-menu.guard";
import { ProvideMemberDisabledGuard } from "src/app/guards/provide-member-disabled.guard";
import { ProvideStoragesGuard } from "src/app/guards/provide-storages.guard";
import { ProvideAppointmentConfigurationGuard } from "src/app/guards/configuration/provide-appointment-configuration.guard";
import { ProvideBillingConfigurationGuard } from "src/app/guards/configuration/provide-billing-configuration.guard";
import { ProvideConfigurationGuard } from "src/app/guards/configuration/provide-configuration.guard";
import { ProvideHealthcareConfigurationGuard } from "src/app/guards/configuration/provide-healthcare-configuration.guard";
import { ProvideWarehouseConfigurationGuard } from "src/app/guards/configuration/provide-warehouse-configuration.guard";
import { AuthenticateWithTokenGuard } from "src/app/guards/authenticate-with-token.guard";
import { ProvideBaseLocaleOverrideGuard } from "src/app/guards/provide-base-locale-override.guard";
import { SyncLocaleWithTenantAvailableGuard } from "src/app/guards/sync-locale-with-tenant-available.guard";
import { MountIframePdfViewerGuard } from "src/app/guards/mount-iframe-pdf-viewer.guard";
import { TranslocoModule } from "@jsverse/transloco";
import { HideAppLoaderGuard } from "src/app/guards/hide-app-loader.guard";
import { ProvideAdminMemberAuthGuard } from "src/app/guards/provide-member-auth/provide-admin-member-auth.guard";
import { ProvideRegionGuard } from "src/app/guards/provide-region.guard";
import { RocketBackupStickyToastGuard } from "src/app/guards/rocket-backup-sticky-toast.guard";
import { ProvideOrganizationConfigurationGuard } from "src/app/guards/configuration/provide-organization-configuration.guard";
import { RestoreTabsGuard } from "src/app/guards/restore-tabs.guard";
import { AllowExecutionSingleTabGuard } from "src/app/guards/allow-execution-single-tab.guard";
import { ProvideIntegrationsGuard } from "src/app/guards/provide-integrations.guard";
import { AfterReloadMessagesNotifierGuard } from "src/app/guards/after-reload-messages-notifier.guard";
import { EnablePWAGuard } from "src/app/guards/enable-pwa.guard";
import { TenantRouterGuard } from "src/app/guards/tenant-router.guard";
import { OnboardingGuard } from "src/app/guards/onboarding.guard";
import { SkipOnboardingGuard } from "src/app/guards/skip-onboarding.guard";
import { MemberAuthProviderModule } from "src/app/services/member-auth-provider/member-auth.provider.module";
import { StatusPageGuard } from "src/app/guards/status-page.guard";
import { UserReadyGuard } from "src/app/guards/user-ready.guard";
import { ConfigureAuthForDropPageGuard } from "src/app/guards/configure-auth-for-drop-page.guard";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    PipesModule,
    MemberAuthProviderModule
  ],
  declarations: [],
  providers: [
    StatusPageGuard,
    AllowExecutionSingleTabGuard,
    HideAppLoaderGuard,
    AuthenticateWithTokenGuard,
    UpdateGuard,
    SessionGuard,
    AuthGuard,
    SignoutGuard,
    ProvideAuthenticatedUserGuard,
    ProvideFacilityGuard,
    ProcessInviteGuard,
    ProvideUserGuard,
    EnableServerEventsGuard,
    EnablePWAGuard,
    EnableIdleSessionGuard,
    TabCanDeactivateGuard,
    ProvideBoxGuard,
    ProvideBreedGuard,
    CookieAuthStorageGuard,
    RoleGuard,
    ProvideMemberGuard,
    ProvideMemberDisabledGuard,
    ProvideMemberAuthGuard,
    ProvideAdminMemberAuthGuard,
    DefaultRouteByRoleGuard,
    ShowUpdateToastGuard,
    ProvideColorsGuard,
    ProvideAvatarGuard,
    ProvideFiscalProfilesGuard,
    ProvideConfigurationGuard,
    ProvideBillingConfigurationGuard,
    ProvideAppointmentConfigurationGuard,
    ProvideHealthcareConfigurationGuard,
    ProvideOrganizationConfigurationGuard,
    ProvideWarehouseConfigurationGuard,
    ProvideBaseLocaleOverrideGuard,
    SyncLocaleWithTenantAvailableGuard,
    ProvideStoragesGuard,
    ProvideMenuGuard,
    EnableThemeGuard,
    EnableAbac,
    MountIframePdfViewerGuard,
    ProvideRegionGuard,
    RocketBackupStickyToastGuard,
    RestoreTabsGuard,
    ProvideIntegrationsGuard,
    AfterReloadMessagesNotifierGuard,
    TenantRouterGuard,
    LockIfSessionIsDeadGuard,
    OnboardingGuard,
    SkipOnboardingGuard,
    UserReadyGuard,
    ConfigureAuthForDropPageGuard
  ]
})
export class GuardsModule {}
